import { db } from "../lib/firebaseApp";
import {
    doc,
    deleteDoc,
    getDocs,
    setDoc,
    collection,
    addDoc,
    serverTimestamp,
    getDoc,
    query,
    where
} from "firebase/firestore";

import { f_import_cowman_array, f_recursive_delete } from "./fbFunctions";






// ------------------------------------------------------------------------
export const add_Cowman = async (user_id, event_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "EVENTS", event_id, "COWMANS"), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_Cowman:\n", error)
        }
        return (undefined)
    }
}


// ------------------------------------------------------------------------
export const edit_Cowman = async (user_id, event_id, cowman_id, data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "EVENTS", event_id, "COWMANS", cowman_id), {
            ...data,
            id: cowman_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_Cowman:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const delete_Cowman = async (event_id, cowman_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "COWMANS", cowman_id)))
        if (docSnap.exists()) {
            await deleteDoc(doc(db, "EVENTS", event_id, "COWMANS", cowman_id));
            return (true)
        } else {
            return (false)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> delete_Cowman:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Cowman_byID = async (event_id, cowman_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "COWMANS", cowman_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Cowman_byID:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Cowman_list = async (event_id, cowman_type, cb_error) => {
    try {
        const cowman_list = []
        let q = query(collection(db, "EVENTS", event_id, "COWMANS"))
        if (cowman_type != null) q = query(q, where("cowman_type", "==", cowman_type))

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const cowman_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", cowman_data);
            cowman_list.push(cowman_data)
        });
        return (cowman_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Cowman_list:\n", error)
        }
        return ([])
    }
}



// ----------------------------------------------------------------------------


/**
 * importa, nell'evento indicato, la lista delle vacche (convertendo i parametri DATA)
 * 
 * @param {string} event_id - id evento
 * @param {list} cowman_array - list dei dati delle vacche da importare
 * @param {list} date_key_list - lista dei nomi dei parametri che sono DATE e che quindi vanno convertiti in timestamp in firebase
 * @returns 
 */
export const import_cowmans = async (event_id, cowman_array, date_key_list) => {
    console.log("import_cowmans:\n\t", event_id, "\n", cowman_array, "\n", date_key_list)

    const res = await f_import_cowman_array({ event_id, cowman_array, date_key_list })
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            const retValue = data.retval;
            return retValue
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in import_cowmans cloud function\nError [", code, "]: \n", message, "\n", details)
            return []
        });

    return res
}


// ----------------------------------------------------------------------------
/**
 * Cancella la collection COWMANS e tutti documenti cow al suo interno
 * 
 * @param {string} event_id - id dell'evento da cui cancellare la collection 
 * @returns 
 */
export const clear_all_cowmans = async (event_id) => {
    console.log("clear_all_cowmans ", event_id)
    
    const path = "EVENTS/" + event_id + "/COWMANS"
    const res = await f_recursive_delete({ path})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.path;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in clear_all_cowmans cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return res
}